import './HomePageCss/CorporateWillSection.css';
import AnimatedText from '../../AnimatedText';
import { useNavigate } from 'react-router-dom';
// import Slider from "react-slick";

// import tcs from '../../Assets/tcs.png';
// import wipro from '../../Assets/wipro.png';
// import itc from '../../Assets/itc.png';

export default function CorporateWillSection() {
    const navigator = useNavigate();

    const handleKnowmorebtn = (e) =>{
        // e.preventDefault;
        navigator("/corporate-wellness");
    }

    return (
        <div className="corporateContainer">
            <div className="textSection">
                <h4 className="rb-headingTag cw-headingTag">Corporate Wellness</h4>
                <div className="headLineText corporateHeadLineText">
                    <h2 className="rb-title rb-corporates">Preferred Diagnostic Partner for Corporates Across Industries</h2>
                    {/* <AnimatedText tag="h2" type="words" y={30} className="rb-title rb-corporates">
                        Preferred Diagnostic Partner for Corporates Across Industries
                    </AnimatedText> */}

                </div>
                <button className=' rbdButton'><span className='btn-text' onClick={handleKnowmorebtn}>Click to Know More...</span></button>
            </div>

            {/* <div className="companiesSection">
                <div className="sliderWrapper">
                    <Slider ref={sliderRef} {...settings}>
                        {companies.map((company, index) => (
                            <div key={index} className="companyCard">
                                <img src={company.logo} alt={company.cName} />
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className="buttonWrapper">
                    <button className="moreBtn" onClick={handleMoreClick}>More</button>
                </div>
            </div> */}
        </div>
    );
}
